import { render } from "./OverviewSection.vue?vue&type=template&id=ff7cdfc0&scoped=true"
import script from "./OverviewSection.vue?vue&type=script&lang=js"
export * from "./OverviewSection.vue?vue&type=script&lang=js"

import "./OverviewSection.vue?vue&type=style&index=0&id=ff7cdfc0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7cdfc0"]])

export default __exports__